var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup925(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 97.075,
    height: 84.193,
    viewBox: "0 0 97.075 84.193",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#98daf0;}.b{fill:none;stroke:#1c2253;stroke-miterlimit:10;stroke-width:4px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1406.75 -1701.957)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1406.75 1701.957)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-233.131,679.193a4.113,4.113,0,0,1-1.981-.509,4.355,4.355,0,0,1-.524-.343l-1.274-.888c-3.047-2.119-10.177-7.076-14.9-10.726-18.128-14.113-27.386-24.286-29.148-32.028a29.62,29.62,0,0,1-1.381-8.792,31.271,31.271,0,0,1,8.708-22.256,26.669,26.669,0,0,1,18.992-8.152h0a27.826,27.826,0,0,1,20.565,8.892A27.485,27.485,0,0,1-213.705,595l.525,0c15.181,0,27.7,13.32,27.911,29.691a31.01,31.01,0,0,1-1.255,9.185c-1.465,7.418-10.712,18.15-28.176,32.454a175.443,175.443,0,0,1-16.232,12.224,4.113,4.113,0,0,1-2.2.639Z",
    transform: "translate(282.342 -595)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-228.623,606.615l-32.127,14.828v42.012h23.477v-19.77h17.3v19.77H-196.5V621.443Z",
    transform: "translate(1692.352 1108.71)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup925);
export default __webpack_public_path__ + "static/media/Group 925.2701b76dca65e01201e0efbb157948b6.svg";
export { ForwardRef as ReactComponent };